import { TranslationRepository } from '../data/translation-repository';
import { VersionsResponse, VersionQueryParams } from '../types/translation-types';

export class GetVersionsUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(params: VersionQueryParams): Promise<VersionsResponse> {
    return this.repository.getVersions(params);
  }
}
